import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('donationCategory', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific donationCategory
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to donationCategory
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`donationCategory/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a donationCategory. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('donationCategory', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific donationCategory
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`donationCategory/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete donationCategory
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`donationCategory/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
